export const normalizeString = (value: string) => {
  return value?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '')
}

export const slugify = (value: string) => {
  return normalizeString(value)
    ?.toLowerCase()
    ?.replace(/ /g, '-')
    ?.replace(/[^\w-]+/g, '')
}

export const composeClasses = (
  ...classes: (string | undefined | null | boolean)[]
) => {
  const filteredClasses = classes?.filter(Boolean)
  return filteredClasses?.join(' ')?.trim()
}

export const copyToClipboard = async (text: string, onSuccess?: () => void) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    console.error('execCommand error:', err)
  }
  if (onSuccess) {
    onSuccess()
  }
}
